import React, { useEffect, useState } from 'react';
import { useAuth } from '../../providers/auth_provider';
import axios from 'axios';
import { Helmet } from 'react-helmet';

export default function UsersDeltaAmounts() {
    const { token } = useAuth();
    const [deltaAmounts, setDeltaAmounts] = useState([]);
    const [pagination, setPagination] = useState({});
    const [searchName, setSearchName] = useState('');
    const [searchEmail, setSearchEmail] = useState('');
    const [searchPhone, setSearchPhone] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [deltaAmount, setDeltaAmount] = React.useState(0);


    useEffect(() => {
        fetchDeltaAmounts(currentPage);
    }, [currentPage, limit, searchName, searchEmail, searchPhone]);

    // Function to fetch delta amounts
    const fetchDeltaAmounts = async (page) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/admin/get/users/delta/amount?page=${page}&limit=${limit}&name=${searchName}&email=${searchEmail}&phone=${searchPhone}`, {
                headers: {
                    Signature: `${process.env.REACT_APP_API_SIGNATURE}`,
                    Authorization: `Bearer ${token}`,
                },
            });
            setDeltaAmounts(response.data.data);
            setPagination(response.data.pagination);
        } catch (error) {
            console.error('Error fetching delta amounts:', error);
        }
    };

    // Function to handle page change
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const fetchAllData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/admin/get/users/delta/amount/statistics`, {
                headers: {
                    Signature: `${process.env.REACT_APP_API_SIGNATURE}`,
                    Authorization: `Bearer ${token}`,
                },
            });
            setDeltaAmount(response.data.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        fetchAllData();
    }, [token]);

    return (
        <>
            <Helmet>
                <title>Manage Delta Amounts - Enervybe</title>
            </Helmet>
            <div className="card">
                <div className="card-header align-items-center border-bottom">
                    <div className="d-flex justify-content-between">
                        <h5 className="card-title">Delta Amounts List</h5>
                    </div>
                </div>

                <div className="card-datatable text-nowrap">

                    <div className="dataTables_wrapper dt-bootstrap5 no-footer">
                        <div className="row g-6 mb-6">
                            <div className="col-sm-6 col-lg-3">
                                <div className="card card-border-shadow-primary h-100">
                                    <div className="card-body">
                                        <div className="d-flex align-items-center mb-2">
                                            <div className="avatar me-4">
                                                <span className="avatar-initial rounded-3 bg-label-primary">
                                                    <i className="ri-arrow-up-down-line ri-24px" />
                                                </span>
                                            </div>
                                            <h4 className="mb-0">${deltaAmount || 0}</h4>
                                        </div>
                                        <h6 className="mb-0 fw-normal">Total Users Delta Amount</h6>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12 col-md-6">
                                <div className="dataTables_length">
                                    <label>
                                        Show{' '}
                                        <select
                                            name="DataTables_Table_0_length"
                                            aria-controls="DataTables_Table_0"
                                            className="form-select form-select-sm"
                                            value={limit}
                                            onChange={(e) => setLimit(e.target.value)}
                                        >
                                            <option value={5}>5</option>
                                            <option value={10}>10</option>
                                            <option value={25}>25</option>
                                            <option value={50}>50</option>
                                            <option value={100}>100</option>
                                        </select>{' '}
                                        entries
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table
                                className="datatables-ajax table table-bordered dataTable no-footer"
                                aria-describedby="DataTables_Table_0_info">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Name</th>
                                        <th>Email Id</th>
                                        <th>Phone No</th>
                                        <th>Delta Amount</th>
                                        {/* <th>Actions</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td></td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="search name"
                                                value={searchName}
                                                onChange={(e) => setSearchName(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="search email"
                                                value={searchEmail}
                                                onChange={(e) => setSearchEmail(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="search phone"
                                                value={searchPhone}
                                                onChange={(e) => setSearchPhone(e.target.value)}
                                            />
                                        </td>
                                        <td></td>

                                    </tr>

                                    {deltaAmounts?.map((deltaAmount, index) => (
                                        <tr key={deltaAmount.id}>
                                            <td>{index + 1}</td>
                                            <td>{deltaAmount.first_name + ' ' + deltaAmount.last_name || "NA"}</td>
                                            <td>{deltaAmount.email || "NA"}</td>
                                            <td>{deltaAmount.country_code + ' ' + deltaAmount.phone_no || "NA"}</td>
                                            <td>
                                                ${typeof deltaAmount?.wallet_balance === 'string' && deltaAmount?.wallet_balance?.includes('.') ? deltaAmount?.wallet_balance : `${deltaAmount.wallet_balance}.00` || "NA"}
                                            </td>
                                            {/* <td>{deltaAmount.status || "NA"}</td> */}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <nav aria-label="Page navigation">
                    <ul className="pagination pagination-sm pt-2">
                        <li className={`page-item prev ${currentPage === 1 ? 'disabled' : ''}`}>
                            <a
                                className="page-link waves-effect"
                                href="#"
                                onClick={() => handlePageChange(currentPage - 1)}
                            >
                                <i className="tf-icon ri-skip-back-mini-line ri-20px" />
                            </a>
                        </li>
                        {pagination.pages && pagination.pages.map((page) => (
                            <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                                <a
                                    className="page-link waves-effect"
                                    href="#"
                                    onClick={() => handlePageChange(page)}
                                >
                                    {page}
                                </a>
                            </li>
                        ))}
                        <li className={`page-item next ${currentPage === pagination.totalPages ? 'disabled' : ''}`}>
                            <a
                                className="page-link waves-effect"
                                href="#"
                                onClick={() => handlePageChange(currentPage + 1)}
                            >
                                <i className="tf-icon ri-skip-forward-mini-line ri-20px" />
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        </>
    );
}
